import React from "react";
import "./CategoryGroupSection.css";

export default function CategoryGroupSection({ groups = [] }) {
  const visibleGroups = (groups || []).filter((group) => {
    const title = String(
      group?.title || group?.group_name || group?.name || ""
    ).trim();

    return title.length > 0;
  });

  return (
    <section className="cg-section">
      <div className="cg-container">
        {visibleGroups.map((group) => {
          const title = String(
            group?.title || group?.group_name || group?.name || ""
          ).trim();

          return (
            <div className="cg-card" key={group.id || title}>
              <h2 className="blackcolor" style={{ marginBottom: 0,color:'black !important' }}>{title}</h2>

              <div className="cg-items">
                {group.items?.map((item) => (
                  <div className="cg-item" key={item.id}>
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.name}
                        className="cg-image"
                      />
                    ) : (
                      <div className="cg-icon">{item.icon}</div>
                    )}

                    <span>{item.name}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}